export default __webpack_public_path__ + "static/media/instagramLogo.2e3b4d78.png";